import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetSearchConditionsGetRequestModel, GetSearchConditionsGetResponseModel } from "@/features/accounts/shared/services/get-search-conditions-model";

export class GetSearchConditionsApi {
  /**
   * 検索条件取得API
   */
  public getSearchConditions = async (
    param: GetSearchConditionsGetRequestModel
  ): Promise<GetSearchConditionsGetResponseModel[]> => {
    const path = `/api/searchconditions`;
    const res = await ApiClient.instance.get<GetSearchConditionsGetResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
